"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _InvoicesCard = _interopRequireDefault(require("./InvoicesCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _InvoicesCard.default;
exports.default = _default;